<odl-dialog
  class="offline-dialog"
  [label]="'OFFLINE_READING' | translate"
  [open]="true"
  (odl-close)="close()"
>
  <div class="offline-dialog__body">
    @switch (state()) {
      @case ('checking') {
        <odl-progress type="circular" class="offline-dialog__spinner"></odl-progress>
      }
      @case ('unsupported') {
        <p>{{ 'OFFLINE.UNSUPPORTED' | translate }}</p>
      }
      @case ('downloading') {
        <p>{{ 'OFFLINE.DOWNLOADING' | translate }}</p>
        <odl-progress [value]="progress()" max="100">
          <span slot="end">{{ progress() }}%</span>
        </odl-progress>
      }
      @case ('deleting') {
        <p>{{ 'OFFLINE.DELETING' | translate }}</p>
        <odl-progress type="circular" class="offline-dialog__spinner"></odl-progress>
      }
      @case ('downloaded') {
        <p>
          {{ (isOffline() ? 'OFFLINE.DOWNLOADED_OFFLINE' : 'OFFLINE.DOWNLOADED') | translate }}
        </p>
        @if (loanEnd(); as loanEnd) {
          <p class="offline-dialog__meta">
            {{ 'OFFLINE.AVAILABLE_UNTIL' | translate: { date: (loanEnd | date: 'mediumDate') } }}
          </p>
        }
        @if (extensionStatus() === 'unsupportedBrowser') {
          <odl-callout variant="info">{{ bookmarkHintKey | translate }}</odl-callout>
        } @else {
          <odl-callout variant="info">{{ 'OFFLINE.OPEN_FROM_EXTENSION' | translate }}</odl-callout>
        }
      }
      @default {
        @if (isOffline()) {
          <p>{{ 'OFFLINE.CONNECTION_REQUIRED' | translate }}</p>
        } @else if (extensionStatus() === 'missing') {
          <p>{{ 'OFFLINE.INSTALL_EXTENSION_MESSAGE' | translate }}</p>
          <p>{{ 'OFFLINE.INSTALL_EXTENSION_DETAIL' | translate }}</p>
        } @else if (extensionStatus() === 'checking') {
          <odl-progress type="circular" class="offline-dialog__spinner"></odl-progress>
        } @else {
          @if (state() === 'error') {
            <odl-callout variant="error">{{ 'OFFLINE.ERROR' | translate }}</odl-callout>
          } @else if (state() === 'noSpace') {
            <odl-callout variant="error">{{ 'OFFLINE.NO_SPACE' | translate }}</odl-callout>
          }
          @if (downloadedElsewhere()) {
            <odl-callout variant="warning">
              {{ 'OFFLINE.DOWNLOADED_ELSEWHERE' | translate }}
            </odl-callout>
          }
          <p>{{ 'OFFLINE.DESCRIPTION' | translate }}</p>
          @if (sizeMb()) {
            <p class="offline-dialog__meta">{{ sizeMb() | number: '1.0-2' }} MB</p>
          }
        }
      }
    }
  </div>

  <div slot="footer" class="offline-dialog__footer">
    @if (state() === 'downloaded' && !isOffline()) {
      <odl-button variant="secondary" (click)="remove()">
        {{ 'OFFLINE.DELETE' | translate }}
      </odl-button>
    } @else if (
      (state() === 'idle' || state() === 'error' || state() === 'noSpace') && !isOffline()
    ) {
      @if (extensionStatus() === 'missing') {
        <odl-button variant="secondary" (click)="checkExtension()">
          {{ 'OFFLINE.CHECK_AGAIN' | translate }}
        </odl-button>
        <odl-button (click)="installExtension()">
          {{ 'OFFLINE.INSTALL_EXTENSION' | translate }}
        </odl-button>
      } @else if (extensionStatus() !== 'checking') {
        <odl-button (click)="download()">
          {{ (state() === 'idle' ? 'OFFLINE.DOWNLOAD' : 'OFFLINE.RETRY') | translate }}
        </odl-button>
      }
    }
  </div>
</odl-dialog>
